import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteMachine, getMachines } from "../../../actions/machines/machines";
import MachineListComponent from "../../../components/Definition/Machine/MachineListComponent";

export default function MachineScreen() {
    const [machine, setMachine] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getMachines({page:params.toString()});
                setLoading(false);
                setMachine(usersData.status !== "error" ? usersData.message : { data: [], meta: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <MachineListComponent lists={machine} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید دستگاه حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteMachine(id);
                    if (response.status === "success") {
                        toast.success("دستگاه حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف دستگاه!");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
